import { render, staticRenderFns } from "./TnmConfiguration.vue?vue&type=template&id=13f57a39&scoped=true"
import script from "./TnmConfiguration.vue?vue&type=script&lang=ts"
export * from "./TnmConfiguration.vue?vue&type=script&lang=ts"
import style0 from "./TnmConfiguration.vue?vue&type=style&index=0&id=13f57a39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f57a39",
  null
  
)

export default component.exports